import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-long-arrow-right-bold",
  "use": "foquz-icon-long-arrow-right-bold-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol viewBox=\"0 0 13 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-long-arrow-right-bold\"><path d=\"M9 1l3 3m0 0L9 7m3-3H1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol